import utils from 'lib/utils';
import Chaplin from 'chaplin';
import EF from 'ef/ef';
import _ from 'lodash';

const EnrollmentDataService = {
  saveData: function (key, data, retries = 3) {
    const wait = 2000;

    const options = {
      success: function () {
        Chaplin.mediator.publish(`enrollment-data-saved:${key}`, data);
        Chaplin.mediator.publish('enrollment-data-saved', data);
      },
      error: (model, response) => {
        Chaplin.mediator.publish(`enrollment-data-failed:${key}`, data);

        // for now all we really care about is conflicts
        if (response.status !== 409 && retries <= 0) {
          return;
        }

        setTimeout(() => {
          // grab data since last save attempt, it might have changed.
          const updatedData = EF.enrollment.getData(key);

          //update retries left
          retries--;

          // attempt another save
          this.saveData(key, updatedData, retries);
        }, wait);
      },
    };
    EF.enrollment.setData(key, data, options);
  },
  saveDataByDotString: function (dotString, data) {
    const parentKey = dotString.split('.')[0];
    const relativeKey = dotString.split('.').slice(1).join('.');
    const oldValue = this.getData(parentKey) || {};
    const newValue = _.set(oldValue, relativeKey, data);
    this.saveData(parentKey, newValue);
  },
  getByDotString: function (dotString) {
    return utils.getByDotString(dotString, this.getData);
  },
  getData: function (key, options = {}) {
    let data;
    if (EF.enrollment && EF.enrollment.attributes) {
      data = EF.enrollment.getData(key);
    }
    Chaplin.mediator.publish(`enrollment-data-loaded:${key}`, data);
    if (data !== undefined && data !== null) {
      return data;
    } else if (options.defaultValue !== undefined) {
      return options.defaultValue;
    } /* istanbul ignore next: deprecated */ else if (options.page) {
      this.redirectForData(key, options);
    }
  },
  /* istanbul ignore next: deprecated */
  redirectForData(key, options) {
    options.redirectBack = options.redirectBack === undefined ? true : options.redirectBack;
    const path = EF.module ? EF.module.currentActivity.currentPage.path() : window.location.hash.replace('#');
    if (options.redirectBack) {
      Chaplin.mediator.subscribeOnce(`enrollment-data-saved:${key}`, () => {
        utils.redirectTo({ url: path });
      });
    }
    utils.redirectTo({ url: options.page });
  },
};

export default EnrollmentDataService;
